import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  tableCell: {
    fontSize: '14px',
  },
});
